module.exports = __webpack_public_path__ + "images/warehouse2.ff74898.png";


//////////////////
// WEBPACK FOOTER
// ./public/assets/image/warehouse2.png
// module id = 644
// module chunks = 0